export default "__VITE_ASSET__DjTDwh8f__"